<h1 mat-dialog-title>{{'common.errorsHeader' | translate}}</h1>
<mat-dialog-content class="mat-typography">
    <blockquote>
        <p *ngFor="let error of errors">{{error}}</p>
    </blockquote>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-end">
    <button mat-button mat-dialog-close>{{'common.close' | translate}}</button>
</mat-dialog-actions>